import React from 'react';

const NewsThumbnail = ({ imageUrl, title, description, date, big }) => {
    const formatDate = (date) => {
        if (date === null) {
            return "";
        }
        return date.split('T')[0] + ' ' + date.split('T')[1].replace('Z', '').split(':')[0] + ":" + date.split('T')[1].replace('Z', '').split(':')[1]
    }

    return (
        <div className="flex phone:flex-col desktop:flex-row rounded overflow-hidden shadow-lg bg-white">
            <div className="desktop:w-1/3 phone:w-full desktop:h-[50px]">
                <img src={imageUrl} alt={title} className={`desktop:w-full phone:w-full ${big} object-fill`} />
            </div>
            <div className="px-2 py-2 desktop:w-1/2 phone:w-[80%]">
                <div className='flex flex-col'>
                    <div className='flex flex-col overflow-clip'>
                        <div className="font-bold text-[15px]" title={title}>{title}</div>
                    </div>
                    <div className='flex flex-col justify-between'>
                        <div className='w-[100%] overflow-hidden text-sm text-gray-600]'>
                            <article className="text-gray-700 truncate" dangerouslySetInnerHTML={{__html: description}}></article>
                        </div>
                        <div>
                            <div className="flex justify-start items-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-3 w-3"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 6V12L16 14"
                                    />
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M12 6V12L8 14"
                                    />
                                    <circle cx={12} cy={12} r={10}/>
                                </svg>
                                <p className="text-gray-400 text-[13px] ml-1">{formatDate(date)}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsThumbnail;